import type { ReactNode } from "react";
import {
  InformationCircleIcon,
  ExclamationTriangleIcon,
  LightBulbIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";

type Variant = "info" | "warning" | "tip" | "success";

const styles: Record<Variant, { wrap: string; icon: string; Icon: typeof InformationCircleIcon }> = {
  info: {
    wrap: "border-forest-200 bg-forest-50 text-forest-900",
    icon: "text-forest-600",
    Icon: InformationCircleIcon,
  },
  warning: {
    wrap: "border-gold-300 bg-gold-50 text-bark-900",
    icon: "text-gold-700",
    Icon: ExclamationTriangleIcon,
  },
  tip: {
    wrap: "border-cream-300 bg-cream-100 text-bark-800",
    icon: "text-forest-600",
    Icon: LightBulbIcon,
  },
  success: {
    wrap: "border-forest-300 bg-forest-50 text-forest-900",
    icon: "text-forest-700",
    Icon: CheckCircleIcon,
  },
};

export function Callout({
  variant = "info",
  title,
  children,
}: {
  variant?: Variant;
  title?: string;
  children: ReactNode;
}) {
  const s = styles[variant];
  return (
    <aside className={`my-6 flex gap-4 rounded-xl border-l-4 p-5 ${s.wrap}`}>
      <s.Icon className={`mt-0.5 h-6 w-6 flex-shrink-0 ${s.icon}`} aria-hidden="true" />
      <div className="min-w-0 flex-1">
        {title && <p className="mb-1 font-display text-lg font-semibold">{title}</p>}
        <div className="prose-sm text-current [&>p]:my-2 [&>p:last-child]:mb-0 [&>p:first-child]:mt-0">
          {children}
        </div>
      </div>
    </aside>
  );
}
